export default "__VITE_ASSET__C92HcZ2x__"